<template>
  <Dialog :open="isOpen" @update:open="setIsOpen">
    <DialogContent class="sm:max-w-md">
      <DialogHeader>
        <DialogTitle class="text-2xl font-bold">Upgrade to Unlock More Features</DialogTitle>
        <DialogDescription>
          Your current plan doesn't include access to this feature. Upgrade your plan to unlock this
          and more.
        </DialogDescription>
      </DialogHeader>
      <div class="py-4">
        <p class="font-semibold">Upgrade to the '{{ requiredPlan }}' plan to get access.</p>
      </div>
      <DialogFooter class="sm:justify-start">
        <Button type="button" @click="goToPricing"> View Plans </Button>
        <DialogClose as-child>
          <Button type="button" variant="secondary"> Close </Button>
        </DialogClose>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>

<script setup lang="ts">
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'

const _props = defineProps<{
  isOpen: boolean
  requiredPlan: string
}>()

const emit = defineEmits(['update:isOpen'])

const setIsOpen = (value: boolean) => {
  emit('update:isOpen', value)
}

const goToPricing = () => {
  navigateTo('/pricing')
  setIsOpen(false)
}
</script>
